import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import ReactDOM from 'react-dom';
import { queueESEvents, ESEventTypes } from 'businessLogic/logEventToElasticSearch';
import { Icon, Menu, Rail, Container } from 'semantic-ui-react';
import {
  getWaitingAreaGeneralInfo,
  getWebsiteButtonDetails,
  getWaitingAreaLocalAccessHours,
  restoreAccessWaitingArea,
  getWaitingArea,
  updateWaitingAreaForm,
  getBeforeCallsInfo,
  getBeforeCallsImportantInfo,
  getWaitingAreaOperatingHours,
  getWaitingAreaCallerEntryPoint,
  updateCallerEntryPointForm,
  getDuringCallsInfo,
  checkIsRecordingAvailableOnPortal,
  getAfterCallsInfo,
  getWaitingAreaLogoPauseImage,
  getSupportContactInfo,
  getWaitingAreaInfoForCallers,
  getWaitingAreaShareLinkMessage,
  showAdvancedMenu,
  getGCWASettings,
} from '../../../../actions/waitingArea.js';
import { ValidMe } from '../../../../businessLogic/validation.js';
import Txt from '../../../inputs/textInput.js';
import { clearAllValidationErrors } from '../../../../businessLogic/validation.js';
import {
  updateShowWebsiteButtonWaitingArea,
  updateShowUpdateWaitingAreaLocalAccessHoursModal,
  updateShowViewWaitingAreaLocalAccessHoursModal,
  updateShowUpdateWaitingAreaModal,
  updateShowViewWaitingAreaModal,
  updateShowSuspendWAModal,
  updateShowUpdateWaitingAreaOperatingHoursModal,
  updateShowViewWaitingAreaOperatingHoursModal,
  updateShowWaitingAreaBeforeCallsModal,
  updateShowWaitingAreaBeforeCallsImportantInfoModal,
  showCallerEntryModal,
  showWaitingAreaDuringCallsModal,
  showWaitingAreaAfterCallsModal,
  showWaitingAreaLogoPauseImageModal,
  showDeleteWaitingAreaModal,
  showSupportContactModal,
  showInfoForCallersModal,
  showWAShareLinkMessageModal,
  showConsultNowSettingModal,
  showGCSettingsModal,
} from '../../../../actions/modal.js';
import { NetworkTypes } from '../../../../constants/networkTypes.js';
import { Media } from '../../../../mediaSetting.js';

export default function AdvancedSettings(props) {
  const dispatch = useDispatch();
  const showAdvancedMenuFromRedux = useSelector((state) => state.waitingAreaReducer.showAdvancedMenu);
  const isWAEntryPointAdditionalMsgAllowed = useSelector(
    (state) => state.usersReducer.userProfile.isWAEntryPointAdditionalMsgAllowed
  );
  const isConsultNowFeatureEnabled = useSelector((state) => state.usersReducer.isConsultNowFeatureEnabled);
  const userProfile = useSelector((state) => state.usersReducer.userProfile);

  const showSuspendWaitingAreaModal = () => {
    dispatch(updateShowSuspendWAModal(true));
  };

  const openWebsiteButton = (event) => {
    let cb = () => {
      dispatch(updateShowWebsiteButtonWaitingArea(true));
      clearAllValidationErrors();
    };

    dispatch(getWebsiteButtonDetails(props.waitingArea.id, cb));
  };

  const viewWaitingAreaGeneral = (event) => {
    let cb = () => {
      dispatch(updateShowViewWaitingAreaModal(true));
    };
    queueESEvents(
      ESEventTypes.APICall,
      `In viewWaitingAreaGeneral in setting cog: ${props.waitingArea.id}`,
      'eventType&apiURL',
      {
        apiURL: window.APP.CONFIGURATION.VCCAPI + 'waitingareas/' + props.waitingArea.id + '/calls',
        browserURL: window.location.href,
      },
      null,
      true,
      'info'
    );
    dispatch(getWaitingArea(props.waitingArea.id, cb));
  };
  const editWaitingAreaGeneral = (event) => {
    let cb = (data) => {
      dispatch(updateShowUpdateWaitingAreaModal(true));
      dispatch(updateWaitingAreaForm(data));
    };
    dispatch(getWaitingAreaGeneralInfo(props.waitingArea.id, cb));
  };
  const editGCSettings = (event) => {
    let cb = () => {
      dispatch(dispatch(showGCSettingsModal(true)));
    };
    dispatch(getGCWASettings(props.waitingArea.id, cb));
  };

  const viewWaitingAreaOperatingHoursGeneral = (event) => {
    let cb = () => {
      dispatch(updateShowViewWaitingAreaOperatingHoursModal(true));
    };
    dispatch(getWaitingAreaOperatingHours(props.waitingArea.id, cb));
  };
  const openWaitingAreaBeforeCalls = (event) => {
    let cb = (data) => {
      dispatch(updateShowWaitingAreaBeforeCallsModal(true));
    };
    dispatch(getBeforeCallsInfo(props.waitingArea.id, cb));
  };
  const openWaitingAreaBeforeCallsImportantInfo = (event) => {
    let cb = (data) => {
      dispatch(updateShowWaitingAreaBeforeCallsImportantInfoModal(true));
    };
    dispatch(getBeforeCallsImportantInfo(props.waitingArea.id, cb));
  };

  const editWaitingAreaOperatingHoursGeneral = (event) => {
    let cb = (data) => {
      dispatch(updateShowUpdateWaitingAreaOperatingHoursModal(true));
    };
    dispatch(getWaitingAreaOperatingHours(props.waitingArea.id, cb));
  };

  const viewWaitingAreaLocalAccessHoursGeneral = (event) => {
    let cb = () => {
      dispatch(updateShowViewWaitingAreaLocalAccessHoursModal(true));
    };
    dispatch(getWaitingAreaLocalAccessHours(props.waitingArea.id, cb));
  };
  const editWaitingAreaLocalAccessHoursGeneral = (event) => {
    let cb = (data) => {
      dispatch(updateShowUpdateWaitingAreaLocalAccessHoursModal(true));
    };
    dispatch(getWaitingAreaLocalAccessHours(props.waitingArea.id, cb));
  };

  const viewEditLogoPauseImageAccess = (event) => {
    let cb = () => {
      dispatch(showWaitingAreaLogoPauseImageModal(true));
    };
    dispatch(getWaitingAreaLogoPauseImage(props.waitingArea.id, cb));
  };

  const restoreAccessWA = () => {
    dispatch(restoreAccessWaitingArea(props.waitingArea));
  };

  const openWaitingAreaDuringCalls = (event) => {
    let cb = (data) => {
      dispatch(showWaitingAreaDuringCallsModal(true));
    };
    dispatch(getDuringCallsInfo(props.waitingArea.id, cb));
    dispatch(checkIsRecordingAvailableOnPortal());
  };

  const openWaitingAreaCallerEntryPoint = (event) => {
    let cb = (data) => {
      dispatch(updateCallerEntryPointForm(data));
      dispatch(showCallerEntryModal(true));
    };

    dispatch(getWaitingAreaCallerEntryPoint(props.waitingArea.id, cb));
  };

  const openWaitingAreaAfterCalls = (event) => {
    let cb = (data) => {
      dispatch(showWaitingAreaAfterCallsModal(true));
    };
    dispatch(getAfterCallsInfo(props.waitingArea.id, cb));
  };

  const openConsultNowSettingModal = (event) => {
    // getWaitingArea not returning promise that's why had to use callback
    let cb = (data) => {
      dispatch(showConsultNowSettingModal(true));
    };
    dispatch(getWaitingArea(props.waitingArea.id, cb));
  };

  const openDeleteWaitingArea = (event) => {
    dispatch(showDeleteWaitingAreaModal(true));
  };

  const openSupportContact = (event) => {
    let cb = (data) => {
      dispatch(showSupportContactModal(true));
    };
    dispatch(getSupportContactInfo(props.waitingArea.id, cb));
  };

  const openWAShareLinkMessage = (event) => {
    let cb = (data) => {
      dispatch(showWAShareLinkMessageModal(true));
    };

    dispatch(getWaitingAreaShareLinkMessage(props.waitingArea.id, cb));
  };

  const openInfoForCallers = (event) => {
    let cb = (data) => {
      dispatch(showInfoForCallersModal(true));
    };

    dispatch(getWaitingAreaInfoForCallers(props.waitingArea.id, cb));
  };

  const btnOnClick = () => {
    dispatch(showAdvancedMenu(!showAdvancedMenuFromRedux));
  };

  const closeMenu = () => {
    dispatch(showAdvancedMenu(false));
  };

  const { waitingArea } = props;
  let finalOptions = [];
  if (waitingArea && waitingArea.permissions && waitingArea.permissions.length > 0) {
    const hasManageWaitingAreaAccess = waitingArea.permissions.indexOf('MANAGE_ACCESS') > -1;
    const hasEditWaitingAreaAccess = waitingArea.permissions.indexOf('EDIT') > -1;
    const hasViewWaitingAreaAccess = waitingArea.permissions.indexOf('VIEW') > -1;
    const hasManageRolesAccess = waitingArea.permissions.indexOf('MANAGE_MEMBER_ROLES') > -1;
    const hasViewTagsAccess =
      waitingArea.reportingTagsEnabled && waitingArea.permissions.indexOf('VIEW_ASSIGNED_TAGS') > -1;

    const isChatFeatrueEnabled = userProfile.isChatFeatrueEnabled;
    const isFullNameFeatureEnabled = userProfile.isFullNameFeatureEnabled;

    finalOptions = [
      {
        key: 0,
        content: APP.LANGUAGE.ViewOneWaitingArea.SuspendAccess,
        'data-show': hasManageWaitingAreaAccess && !waitingArea.isSuspended,
        onClick: showSuspendWaitingAreaModal,
      },
      {
        key: 1,
        content: APP.LANGUAGE.ViewOneWaitingArea.RestoreAccess,
        onClick: restoreAccessWA,
        'data-show': hasManageWaitingAreaAccess && waitingArea.isSuspended,
      },
      {
        key: 2,
        content: APP.LANGUAGE.ViewOneWaitingArea.ManageUsers,
        as: Link,
        to: `/waiting-area/manage-users/${waitingArea.id}`,
        'data-show': hasManageRolesAccess,
        className: 'no-text-decoration-link',
      },
      {
        key: 3,
        content: APP.LANGUAGE.ViewOneWaitingArea.ManageTags,
        as: Link,
        to: `/waiting-area/manage-tags/${waitingArea.id}`,
        'data-show': hasViewTagsAccess,
        className: 'no-text-decoration-link',
      },
      {
        key: 4,
        content: APP.LANGUAGE.ViewOneWaitingArea.EditProperties,
        onClick: editWaitingAreaGeneral,
        'data-show': hasViewWaitingAreaAccess && hasEditWaitingAreaAccess,
      },
      {
        key: 5,
        content: APP.LANGUAGE.ViewOneWaitingArea.GCSettings,
        onClick: editGCSettings,
        'data-show':
          (isChatFeatrueEnabled || isFullNameFeatureEnabled) &&
          waitingArea.networkTypeId === NetworkTypes.GroupConsultation,
      },
      {
        key: 51,
        content: APP.LANGUAGE.ViewOneWaitingArea.SupportContact,
        onClick: openSupportContact,
        'data-show': hasViewWaitingAreaAccess && hasEditWaitingAreaAccess,
      },
      {
        key: 52,
        content: APP.LANGUAGE.ViewOneWaitingArea.CallerSupportInfo,
        onClick: openInfoForCallers,
        'data-show': hasViewWaitingAreaAccess && hasEditWaitingAreaAccess,
      },
      {
        key: 6,
        content: APP.LANGUAGE.ViewOneWaitingArea.ViewLogoPauseImageAccess,
        onClick: viewEditLogoPauseImageAccess,
        'data-show': hasViewWaitingAreaAccess && hasEditWaitingAreaAccess,
      },
      {
        key: 7,
        content: APP.LANGUAGE.ViewOneWaitingArea.EditLocalVideoCallAccess,
        onClick: editWaitingAreaOperatingHoursGeneral,
        'data-show': hasViewWaitingAreaAccess && hasEditWaitingAreaAccess,
      },
      {
        key: 8,
        content: APP.LANGUAGE.ViewOneWaitingArea.EditLocalVideoCallAccessHours,
        onClick: editWaitingAreaLocalAccessHoursGeneral,
        'data-show': props.isAdmin && hasViewWaitingAreaAccess && hasEditWaitingAreaAccess,
      },
      {
        key: 9,
        content: APP.LANGUAGE.ViewOneWaitingArea.CallerEntry,
        onClick: openWaitingAreaCallerEntryPoint,
        'data-show': hasViewWaitingAreaAccess && hasEditWaitingAreaAccess,
      },
      {
        key: 103,
        content: APP.LANGUAGE.ViewOneWaitingArea.WaitingAreasShareLink,
        onClick: openWAShareLinkMessage,
        'data-show': hasViewWaitingAreaAccess && hasEditWaitingAreaAccess && isWAEntryPointAdditionalMsgAllowed,
      },
      {
        key: 101,
        content: APP.LANGUAGE.ViewOneWaitingArea.BeforeCallsCallers,
        onClick: openWaitingAreaBeforeCalls,
        'data-show': hasViewWaitingAreaAccess && hasEditWaitingAreaAccess,
      },
      {
        key: 102,
        content: APP.LANGUAGE.ViewOneWaitingArea.BeforeCallsImportantInfo,
        onClick: openWaitingAreaBeforeCallsImportantInfo,
        'data-show': hasViewWaitingAreaAccess && hasEditWaitingAreaAccess,
      },
      {
        key: 11,
        content: APP.LANGUAGE.ViewOneWaitingArea.DuringCalls,
        onClick: openWaitingAreaDuringCalls,
        'data-show':
          hasViewWaitingAreaAccess &&
          hasEditWaitingAreaAccess &&
          waitingArea.networkTypeId !== NetworkTypes.GroupConsultation,
      },
      {
        key: 12,
        content: APP.LANGUAGE.ViewOneWaitingArea.AfterCalls,
        onClick: openWaitingAreaAfterCalls,
        'data-show': hasViewWaitingAreaAccess && hasEditWaitingAreaAccess,
      },
      {
        key: 23,
        content: APP.LANGUAGE.ViewOneWaitingArea.EnableConsultNow,
        onClick: openConsultNowSettingModal,
        'data-show':
          hasEditWaitingAreaAccess &&
          isConsultNowFeatureEnabled &&
          waitingArea.networkTypeId !== NetworkTypes.GroupConsultation,
      },
      {
        key: 22,
        content: APP.LANGUAGE.ViewOneWaitingArea.DeleteWaitingArea,
        onClick: openDeleteWaitingArea,
        'data-show': hasViewWaitingAreaAccess && hasEditWaitingAreaAccess,
      },
      {
        key: 14,
        content: APP.LANGUAGE.ViewOneWaitingArea.ViewProperties,
        onClick: viewWaitingAreaGeneral,
        'data-show': hasViewWaitingAreaAccess && !hasEditWaitingAreaAccess,
      },
      {
        key: 151,
        content: APP.LANGUAGE.ViewOneWaitingArea.SupportContact,
        onClick: openSupportContact,
        'data-show': hasViewWaitingAreaAccess && !hasEditWaitingAreaAccess,
      },
      {
        key: 152,
        content: APP.LANGUAGE.ViewOneWaitingArea.CallerSupportInfo,
        onClick: openInfoForCallers,
        'data-show': hasViewWaitingAreaAccess && !hasEditWaitingAreaAccess,
      },
      {
        key: 16,
        content: APP.LANGUAGE.ViewOneWaitingArea.ViewLogoPauseImageAccess,
        onClick: viewEditLogoPauseImageAccess,
        'data-show': hasViewWaitingAreaAccess && !hasEditWaitingAreaAccess,
      },
      {
        key: 17,
        content: APP.LANGUAGE.ViewOneWaitingArea.ViewLocalVideoCallAccess,
        onClick: viewWaitingAreaOperatingHoursGeneral,
        'data-show': hasViewWaitingAreaAccess && !hasEditWaitingAreaAccess,
      },
      {
        key: 18,
        content: APP.LANGUAGE.ViewOneWaitingArea.CallerEntry,
        onClick: openWaitingAreaCallerEntryPoint,
        'data-show': hasViewWaitingAreaAccess && !hasEditWaitingAreaAccess,
      },
      {
        key: 203,
        content: APP.LANGUAGE.ViewOneWaitingArea.WaitingAreasShareLink,
        onClick: openWAShareLinkMessage,
        'data-show': hasViewWaitingAreaAccess && !hasEditWaitingAreaAccess && isWAEntryPointAdditionalMsgAllowed,
      },
      {
        key: 191,
        content: APP.LANGUAGE.ViewOneWaitingArea.BeforeCallsCallers,
        onClick: openWaitingAreaBeforeCalls,
        'data-show': hasViewWaitingAreaAccess && !hasEditWaitingAreaAccess,
      },
      {
        key: 192,
        content: APP.LANGUAGE.ViewOneWaitingArea.BeforeCallsImportantInfo,
        onClick: openWaitingAreaBeforeCallsImportantInfo,
        'data-show': hasViewWaitingAreaAccess && !hasEditWaitingAreaAccess,
      },
      {
        key: 20,
        content: APP.LANGUAGE.ViewOneWaitingArea.DuringCalls,
        onClick: openWaitingAreaDuringCalls,
        'data-show':
          hasViewWaitingAreaAccess &&
          !hasEditWaitingAreaAccess &&
          waitingArea.networkTypeId !== NetworkTypes.GroupConsultation,
      },
      {
        key: 21,
        content: APP.LANGUAGE.ViewOneWaitingArea.AfterCalls,
        onClick: openWaitingAreaAfterCalls,
        'data-show': hasViewWaitingAreaAccess && !hasEditWaitingAreaAccess,
      },
      {
        key: 124,
        content: APP.LANGUAGE.ViewOneWaitingArea.EnableConsultNow,
        onClick: openConsultNowSettingModal,
        'data-show':
          hasViewWaitingAreaAccess &&
          !hasEditWaitingAreaAccess &&
          isConsultNowFeatureEnabled &&
          waitingArea.networkTypeId !== NetworkTypes.GroupConsultation,
      },
    ];
  }
  let mobileButton = (
    <div
      className={
        'inline-flex center-flex hand new-advanced-settings-btn ' +
        (props.waitingArea.networkTypeId === NetworkTypes.GroupConsultation ? 'gc' : '')
      }
      onClick={btnOnClick}
    >
      <Icon
        className={
          showAdvancedMenuFromRedux
            ? 'color-gray new-advanced-settings-btn-cog'
            : 'color-setting-cog-grey new-advanced-settings-btn-cog'
        }
        name="setting"
      />
      <Icon
        className={
          showAdvancedMenuFromRedux
            ? 'color-gray new-advanced-settings-btn-chevron mrrnull'
            : 'color-setting-cog-grey new-advanced-settings-btn-chevron mrrnull'
        }
        name="angle down"
      />
    </div>
  );

  return (
    <div>
      <Container fluid as={Media} greaterThanOrEqual="computer">
        <div
          className={props.verticallyCenter ? 'advanced-settings pdll pdt-41' : 'advanced-settings pdll pdtxl'}
          style={{ height: showAdvancedMenuFromRedux ? '100%' : 'auto' }}
        >
          {mobileButton}
          {showAdvancedMenuFromRedux ? (
            <Menu
              vertical
              className={props.verticallyCenter ? 'new-advanced-settings-menu mrt-34' : 'new-advanced-settings-menu'}
            >
              <Menu.Header>
                <Icon name="cancel" className="color-footer-links fr mrtl mrbm mrrl" size="large" onClick={closeMenu} />
                <div className="clear-both" />
              </Menu.Header>
              {finalOptions.map((option) => (
                <Menu.Item key={option.value} {...option} />
              ))}
              <Rail attached position="left">
                <div className="arrow-down" />
              </Rail>
            </Menu>
          ) : (
            ''
          )}
        </div>
      </Container>
      <Container fluid as={Media} lessThan="computer">
        {mobileButton}
        <div className="clear-both" />
        <div className="advanced-settings pdts" style={{ height: 'auto' }}>
          <Menu vertical className="new-advanced-settings-menu pdbl" data-show={showAdvancedMenuFromRedux}>
            <Menu.Header>
              <div className="arrow-down mrrm" />
              <div className="clear-both" />
              <Icon name="cancel" className="color-footer-links fr mrtm mrbm mrrml" size="large" onClick={closeMenu} />
              <div className="clear-both" />
            </Menu.Header>
            {finalOptions.map((option) => (
              <Menu.Item key={option.value} {...option} />
            ))}
          </Menu>
        </div>
      </Container>
    </div>
  );
}
